query AnalyticsViewsMetrics($filter: AnalyticsViewsFilterInput!) {
  analyticsViews(filter: $filter) {
    views
    visitors
    duration
  }
}
